import axios from "@/plugins/axios"
import type { Pagination } from "@/types/common.type"
import type { Address, Purchase } from "@/types/purchase.type"

export interface ListRequest {
  page: string | null
  perPage: string | null
  code: string | null
  customerCode: string | null
  status: string | null
}

async function get(id: number): Promise<Purchase> {
  const resposne = await axios.get<Purchase>(`/purchases/${id}`)
  return resposne.data
}

async function list(request: ListRequest): Promise<Pagination<Purchase>> {
  const response = await axios.get<Pagination<Purchase>>("/purchases", {
    params: request,
  })
  return response.data
}

async function decide(id: number): Promise<Purchase> {
  const response = await axios.put<Purchase>(`/purchases/${id}/decide`)
  return response.data
}

async function getOrderShippingAddress(id: number): Promise<Address> {
  const response = await axios.get<Address>(`/purchases/${id}/order_shipping_address`)
  return response.data
}

const purchaseService = {
  get,
  list,
  decide,
  getOrderShippingAddress,
}

export default purchaseService
